module.exports = __webpack_public_path__ + "img/Hechos.64880206.png";